<template>
  <CCard>
    <CCardHeader>
      <div class="card-title">{{ config.title }}</div>
    </CCardHeader>
    <CCardBody>
      <Formatter :config="config" :dataForm="dataForm" v-on="$listeners" />
    </CCardBody>
    <CCardFooter>
      <vue-ladda
        :loading="this.loading"
        data-style="zoom-in"
        button-class="btn btn-primary"
        @click.prevent="SaveData"
        >{{ $t("common.editor.button.save") }}</vue-ladda
      >
    </CCardFooter>
  </CCard>
</template>

<script>
import Formatter from "./Formatter";
import { apiPatch } from "../../helpers/apiHelper";

var _ = require("lodash");

/*!
 * Find the differences between two objects and push to a new object
 * (c) 2019 Chris Ferdinandi & Jascha Brinkmann, MIT License, https://gomakethings.com & https://twitter.com/jaschaio
 * @param  {Object} obj1 The original object
 * @param  {Object} obj2 The object to compare against it
 * @return {Object}      An object of differences between the two
 */
var diff = function (obj1, obj2) {
  // Make sure an object to compare is provided
  if (!obj2 || Object.prototype.toString.call(obj2) !== "[object Object]") {
    return obj1;
  }

  var diffs = {};
  var key;

  /**
   * Check if two arrays are equal
   * @param  {Array}   arr1 The first array
   * @param  {Array}   arr2 The second array
   * @return {Boolean}      If true, both arrays are equal
   */
  var arraysMatch = function (arr1, arr2) {
    // Check if the arrays are the same length
    if (arr1.length !== arr2.length) return false;

    // Check if all items exist and are in the same order
    for (var i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }

    // Otherwise, return true
    return true;
  };

  /**
   * Compare two items and push non-matches to object
   * @param  {*}      item1 The first item
   * @param  {*}      item2 The second item
   * @param  {String} key   The key in our object
   */
  var compare = function (item1, item2, key) {
    // Get the object type
    var type1 = Object.prototype.toString.call(item1);
    var type2 = Object.prototype.toString.call(item2);

    // If type2 is undefined it has been removed
    if (type2 === "[object Undefined]") {
      diffs[key] = null;
      return;
    }

    // If items are different types
    if (type1 !== type2) {
      diffs[key] = item2;
      return;
    }

    // If an object, compare recursively
    if (type1 === "[object Object]") {
      var objDiff = diff(item1, item2);
      if (Object.keys(objDiff).length > 0) {
        diffs[key] = objDiff;
      }
      return;
    }

    // If an array, compare
    if (type1 === "[object Array]") {
      if (!arraysMatch(item1, item2)) {
        diffs[key] = item2;
      }
      return;
    }

    // Else if it's a function, convert to a string and compare
    // Otherwise, just compare
    if (type1 === "[object Function]") {
      if (item1.toString() !== item2.toString()) {
        diffs[key] = item2;
      }
    } else {
      if (item1 !== item2) {
        diffs[key] = item2;
      }
    }
  };

  //
  // Compare our objects
  //

  // Loop through the first object
  for (key in obj1) {
    compare(obj1[key], obj2[key], key);
  }

  // Loop through the second object and find missing items
  for (key in obj2) {
    if (!obj1[key] && obj1[key] !== obj2[key]) {
      diffs[key] = obj2[key];
    }
  }

  // Return the object of differences
  return diffs;
};

export default {
  name: "CardNew",
  props: ["config"],
  data() {
    return {
      baseDataForm: {
        active: true,
        errors: {},
        dataOrig: {},
      },
      loading: false,
    };
  },
  computed: {
    dataForm() {
      let res = this.baseDataForm;
      res.formData = this.config.data;
      res.formDataOptions = this.config.options;
      res.cur_lang = this.config.cur_lang || this.$i18n.locale;
      return res;
    },
  },
  mounted() {
    this.baseDataForm.dataOrig = JSON.parse(JSON.stringify(this.config.data));
  },
  methods: {
    async SaveData() {
      this.loading = true;
      this.dataForm.errors = {};

      let self = this;

      let params = diff(this.dataForm.dataOrig, this.dataForm.formData);
      params.id = this.config.data.id;
      delete params.ts_created;
      delete params.ts_modified;

      let trans = Object.entries(this.config.fields).reduce(function (
        map,
        val
      ) {
        let name = val[0];
        let obj = val[1];
        if (obj.translate) {
          var tfield = {};
          tfield[obj.translate] = [name];
          map = _.mergeWith(map, tfield, function (objValue, srcValue) {
            if (_.isArray(objValue)) {
              return objValue.concat(srcValue);
            }
          });
        }
        return map;
      },
      {});

      Object.keys(params).forEach(function (key) {
        if (Object.keys(trans).includes(key)) {
          // console.log("CCCC", key, params[key]);
          Object.keys(params[key]).forEach(function (mkey) {
            // console.log("MMMM", mkey)
            trans[key].forEach(function (vkey) {
              // console.log(key, mkey, vkey)
              // console.log(params[key][mkey][vkey])
              if (typeof params[key][mkey][vkey] == "undefined") {
                // console.log(params[key][mkey][vkey])
                // console.log(self.dataForm.dataOrig[key][mkey][vkey])
                params[key][mkey][vkey] =
                  self.dataForm.dataOrig[key][mkey][vkey];
              }
            });
          });
        }
      });

      const response = await apiPatch(
        this.config.endpoint,
        params.id,
        params,
        []
      );

      if (response && response.status === 200) {
        this.loading = false;
        this.$store.dispatch("toaster/add", {
          title: this.$t("user.profile.data.ok.title"),
          text: this.$t("user.profile.data.ok.message"),
          color: "success",
          autohide: true,
        });
      } else if (response && response.errors) {
        this.dataForm.errors = response.errors;
        this.loading = false;
      } else {
        this.dataForm.errors = response;
        Object.entries(response).forEach(([key, value]) => {
          this.$store.dispatch("toaster/add", {
            title: this.$t("common.general.savingError"),
            text: `${value}`,
            color: "danger",
            autohide: true,
          });
        });
        this.loading = false;
      }
    },
  },
  components: {
    Formatter,
  },
};
</script>
